export const PRIMARY = '#268ec6'
export const WHITE = '#FFFFFF'
export const GREY_LIGHT = '#DDDDDD'
export const GREY_DARKER = '#444444'
export const GREY_DARK = '#777777'
export const SUCCESS = '#1cbda4'
export const DANGER = '#e15d71'
export const BLACK = '#333333'
